import ContainedIcon from '@/components/ContainedIcon';
import KimiIconBase from '@/components/Icons/KimiIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function KimiIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Kimi)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <KimiIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Kimi),
        }}
      />
    </ContainedIcon>
  );
}

export default KimiIcon;
